import { createPortal } from 'react-dom';
import { formatShortcutKeys } from '../config/crmNavShortcuts';
import '../styles/crm-shortcuts-premium.css';

function ShortcutKey({ children }) {
  return <kbd className="crm-shortcuts-kbd">{children}</kbd>;
}

export function CrmShortcutsToast({ flash }) {
  if (!flash) return null;
  return (
    <div className="crm-shortcuts-toast" role="status" aria-live="polite">
      <span className="crm-shortcuts-toast__icon" aria-hidden="true">{flash.icon}</span>
      <span>
        {flash.label}
        <span className="crm-shortcuts-toast__keys">{formatShortcutKeys(flash.keys)}</span>
      </span>
    </div>
  );
}

function ShortcutsPanelContent({ shortcuts, onClose, onSelect }) {
  return (
    <div
      className="crm-shortcuts-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="crm-shortcuts-title"
    >
      <div className="crm-shortcuts-panel__accent" aria-hidden="true" />

      <header className="crm-shortcuts-panel__head">
        <div>
          <p className="crm-shortcuts-panel__eyebrow">Grupo Bienestar CRM</p>
          <h2 id="crm-shortcuts-title" className="crm-shortcuts-panel__title">
            Accesos directos
          </h2>
          <p className="crm-shortcuts-panel__sub">
            Saltá al módulo al instante. Solo funcionan fuera de campos de texto.
          </p>
        </div>
        <button
          type="button"
          className="crm-shortcuts-panel__close"
          onClick={onClose}
          aria-label="Cerrar atajos"
        >
          ×
        </button>
      </header>

      {shortcuts.length > 0 ? (
        <div className="crm-shortcuts-panel__list">
          {shortcuts.map((shortcut) => (
            <button
              key={shortcut.id}
              type="button"
              className="crm-shortcuts-card"
              onClick={() => onSelect(shortcut)}
            >
              <span className="crm-shortcuts-card__icon" aria-hidden="true">
                {shortcut.icon}
              </span>
              <span className="crm-shortcuts-card__copy">
                <span className="crm-shortcuts-card__label">{shortcut.label}</span>
                <span className="crm-shortcuts-card__desc">{shortcut.description}</span>
              </span>
              <span className="crm-shortcuts-card__keys">
                {(shortcut.keys || []).map((key) => (
                  <ShortcutKey key={key}>{key}</ShortcutKey>
                ))}
              </span>
            </button>
          ))}
        </div>
      ) : (
        <p className="crm-shortcuts-panel__empty">
          No tenés módulos con atajo asignado para tu perfil actual.
        </p>
      )}

      <footer className="crm-shortcuts-panel__foot">
        <p className="crm-shortcuts-panel__tip">
          Pulse Command: <kbd>Ctrl</kbd>+<kbd>K</kbd> · Guía: <kbd>?</kbd> · <kbd>Esc</kbd>
        </p>
      </footer>
    </div>
  );
}

/** Dock lateral (peek + panel deslizante), mismo patrón que el FAB de WhatsApp */
export function CrmShortcutsDock({ isOpen, shortcuts, onOpen, onClose, onSelect }) {
  if (typeof document === 'undefined') return null;

  return createPortal(
    <div
      className={`crm-shortcuts-shell${isOpen ? ' is-expanded' : ''}`}
      aria-live="polite"
    >
      {isOpen ? (
        <>
          <button
            type="button"
            className="crm-shortcuts-shell__backdrop"
            onClick={onClose}
            aria-label="Cerrar atajos"
          />
          <ShortcutsPanelContent
            shortcuts={shortcuts}
            onClose={onClose}
            onSelect={onSelect}
          />
        </>
      ) : (
        <div className="crm-shortcuts-shell__rail">
          <button
            type="button"
            className="crm-shortcuts-shell__btn"
            onClick={onOpen}
            aria-label="Ver atajos de teclado"
            title="Atajos de teclado (?)"
          >
            <span className="crm-shortcuts-shell__btn-icon" aria-hidden="true">
              ⌨
            </span>
            <span className="crm-shortcuts-shell__btn-key" aria-hidden="true">
              ?
            </span>
          </button>
        </div>
      )}
    </div>,
    document.body
  );
}

export default CrmShortcutsDock;
